/**
 * Neutral AbilitySpec defaults (LoL Ability-data shaped).
 * Kits omit what they do not use; createAbilitySpec merges these in.
 * Numbers are seconds / game units; null = not applicable.
 */

export const ABILITY_SPEC_DEFAULTS = Object.freeze({
  // Timing
  castTime: 0,
  effectDelay: 0,
  duration: 0,
  channelTime: 0,
  // Geometry
  range: 0,
  targetRange: null,
  width: null,
  radius: null,
  innerRadius: null,
  angle: null,
  collisionRadius: null,
  tetherRadius: null,
  travelSpeed: null,
  // Cost / cooldown extras
  costType: 'mana',
  staticCooldown: null,
  cdStart: 'on_cast',
  recharge: null,
  onTargetCd: null,
  maxCharges: null,
  // Damage / status declarations (consumers optional)
  damageType: null,
  spellEffects: null,
  cc: null,
  dot: null,
  // Targeting filters
  affects: 'enemies',
  projectile: false,
  status: 'wired'
});

export const ABILITY_SPEC_OPTIONAL_KEYS = Object.freeze(
  Object.keys(ABILITY_SPEC_DEFAULTS)
);

export const ABILITY_COST_TYPES = Object.freeze(
  new Set(['mana', 'energy', 'none', 'health', 'flow', 'shield', 'ammo'])
);

export const ABILITY_DAMAGE_TYPES = Object.freeze(
  new Set(['physical', 'magic', 'true', 'mixed'])
);

export const ABILITY_SPELL_EFFECTS = Object.freeze(
  new Set(['spell', 'dot', 'periodic', 'attack', 'pet', 'default'])
);

export const ABILITY_AFFECTS = Object.freeze(
  new Set(['enemies', 'allies', 'self', 'all', 'none'])
);

export const ABILITY_CD_START = Object.freeze(
  new Set(['on_cast', 'post_effect', 'custom'])
);

export const ABILITY_CC_TYPES = Object.freeze(
  new Set(['stun', 'root', 'silence', 'slow', 'knockup', 'knockdown', 'charm', 'fear', 'taunt'])
);
